import React from "react";
import { YhBox } from "@/components/YhBox";
import { SearchItem } from "@/components/YhPageHeader/item";
import { Row } from "antd";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { useDetailModel } from "../detailModel";
import { useBillModel } from "./billModel";
import { billStatusDs, ioFlagDs, billCancelStatusDs } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";

export const BIllSearchBox = () => {
    const { orgDs, beDs, customerOptions } = useDetailModel(model => [model.orgDs, model.beDs, model.customerOptions]);
    const {
        onSearch,
        searchParam,
        onReset,
        updateSearchParam,
        loadData
    } = useBillModel()
    const { accountTypeDs, tradeTypeDs } = useGlobalModel()


    const searchProp: ISearchProp = {
        searchValues: searchParam,
        triggerSearch: true,
        handleSearch: (val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val }),
        onChange: (data) => {
            updateSearchParam(data)
        }
    }
    const searchFields: (ISearchProp & ISearchField)[] = [
        {
            type: SearchTypeEnum.TreeSelect,
            xxl: 4,
            span: 4,
            placeholder: "机构",
            fieldName: "orgCode",
            size: "small",
            disabled: false,
            treeDs: orgDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "实体",
            fieldName: "beCode",
            size: "small",
            disabled: false,
            options: beDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "单据类型",
            fieldName: "tradeTypeCode",
            size: "small",
            disabled: false,
            options: tradeTypeDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "账户类型",
            fieldName: "accountTypeCode",
            size: "small",
            options: accountTypeDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "账单编码",
            fieldName: "code",
            size: "small",
            disabled: false,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchButton",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "searchButton",
            onClick: onReset
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "收支类型",
            fieldName: "ioFlag",
            size: "small",
            disabled: false,
            options: ioFlagDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 8,
            span: 8,
            placeholder: "起止",
            fieldName: "time",
            size: "small",
            disabled: false,
            ...searchProp,
            onChange: (data) => {
                let newData = {
                    billTimeRange: data.time[0] !== '' && data.time[1] !== '' ? {
                        startTime: data.time[0] + ' 00:00:00',
                        endTime: data.time[1] + ' 23:59:59'
                    } : undefined,
                    ...data
                }
                updateSearchParam(newData)
            }
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "收款状态",
            fieldName: "status",
            size: "small",
            disabled: false,
            options: billStatusDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "取消状态",
            fieldName: "cancelStatus",
            size: "small",
            disabled: false,
            options: billCancelStatusDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "单据编号",
            fieldName: "tradeCode",
            size: "small",
            disabled: false,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "客户",
            fieldName: "partnerCode",
            size: "small",
            disabled: false,
            options: customerOptions,
            ...searchProp
        },
    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                justify="start"
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el, index) => <SearchItem
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
